<form #newModule="ngForm" (ngSubmit)="createupdatepackage()" class="mb-0">
    <div class="restrict-img-width mw-100 mx-auto mb-3">
      <div *ngIf="logoimg.style.display === 'none'" class="img-placeholder rounded shadow-sm-darker d-flex align-items-center justify-content-center text-xs" [style]="'height:' + settings.moduleImageHeight + 'px'">No Image Added</div>
      <img #logoimg src="{{package.imageUrl}}" alt="Image to be uploaded" class="w-100 bg-black-100 object-cover object-center rounded shadow-sm-darker" style="display: none;">
      <div class="text-center">
        <button (click)="logo.click()" type="button" id="courseHeaderImgLabel" class="btn mx-auto mt-2 mb-1"><i class="fa fa-plus"></i> Add Image</button>
        <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" name="logo" accept="image/*" aria-labelledby="courseHeaderImgLabel" id="courseHeaderImg" class="sr-only">
        <!-- <span class="text-xs">{{settings.moduleImageWidth}} x {{settings.moduleImageHeight}} pixels required</span> -->
      </div>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="schoolname">Package Name <span class="requiredfield">*</span></label>
      <input type="text" [(ngModel)]="package.name" #name name="name" maxlength="200" required class="text-field"
        id="schoolname">
    </div>
    <div class="fieldset fieldset--note">
        <label class="legend">Package Description <span class="requiredfield">*</span></label>
        <quill-editor required #description name="package.description" placeholder="Enter Description of Package"></quill-editor>
      </div>
    <!-- <div class="fieldset fieldset--lg">
      <label class="legend" for="code">Course Code</label>
      <input type="text" [(ngModel)]="packagecourseCode" #courseCode name="courseCode" class="text-field" id="code">
    </div> -->
    <div class="fieldset fieldset--lg">
      <label class="legend" for="amountPerStudent">Price</label>
      <input type="number" [(ngModel)]="package.amountPerStudent" #price name="amountPerStudent" class="text-field" id="amountPerStudent">
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="accessDays">Access Days </label>
      <input type="number" [(ngModel)]="package.accessdays" #accessdays name="accessdays" class="text-field" id="accessDays">
    </div>
    <!-- <div class="fieldset fieldset--lg">
      <label class="legend z-1" for="reqEnroll">Require Enrollment</label>
      <select class="text-field" [(ngModel)]="packagerequireEnrollment" #requireEnrollment name="requireEnrollment"
        id="reqEnroll" [disabled]="packageprice">
        <option [ngValue]="true" selected>
          Yes
        </option>
        <option [ngValue]="false">
          No
        </option>
      </select>
    </div> -->
    
    <div class="d-flex justify-content-center flex-wrap gap-1.5">
      <button class="btn m-0" [disabled]="!newModule.form.valid" type="submit"> Save </button>
      <button class="btn btn--warning m-0" routerLink="/user/schoolhome"> Cancel </button>
    </div>
  </form>
  
  <!-- <div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-add-external-media #addExternalMediaComponent></app-add-external-media>
        </div>
        <div class="modal-footer justify-content-center gap-1.5">
          <button type="button" class="btn m-0" (click)="externalMediaSelected()" [disabled]="!addExternalMediaComponent.mediaurl.trim()">Ok</button>
          <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
        </div>
      </div>
    </div>
  </div> -->
  